/* eslint-disable */
import axios from '@/services/axios'

export default {
    list(search) {
        return axios.get("/campaigns/search", {
            params: search
        });
    },
    get(id) {
        return axios.get(`/campaigns/get/${id}`);
    },
    create(data) {
        return axios.post("/campaigns/create", data);
    },
    update(data) {
        return axios.post("/campaigns/update", data);
    },
    enable(id) {
        return axios.post(`/campaigns/enable/${id}`);
    },
    disable(id) {
        return axios.post(`/campaigns/disable/${id}`);
    },
    delete(id) {
        return axios.delete(`/campaigns/delete/${id}`);
    }
};
